module.exports = __webpack_public_path__ + "static/media/FastPayments.05e7d14b.svg";